define.alias("shared/components/shared/social/connect-profile", "preview-grid/components/shared/social/connect-profile");